export const ExtraProductChooseType = {
  OnlyExtra: "OnlyExtra",
  OnlyProduct: "OnlyProduct",
  All: "All",
};
